module.exports = __webpack_public_path__ + "img/sample04.9b4e688d.gif";